import { defineMessages } from 'react-intl';

export const scope = 'cb.components.Header';

export default defineMessages({
  accountMenuSettingsItemText: {
    id: `${scope}.accountMenuSettingsItemText`,
    defaultMessage: 'Account settings',
  },
  accountMenuSignOutItemText: {
    id: `${scope}.accountMenuSignOutItemText`,
    defaultMessage: 'Sign out',
  },
  pointsBlockPointsText: {
    id: `${scope}.pointsBlockPointsText`,
    defaultMessage: '{ points, plural, one { point } other { points } }',
  },
});
